import React from 'react';
import { I18n } from '@aws-amplify/core';
import { FormItemWrapper } from './FormItemWrapper';

import InputNumber from '@/components/ui/InputNumber';
import { useActivityDuration } from '../hooks/useAcitivityDuration';

interface ActivityDurationFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

export function ActivityDurationFormItem({
	required = true,
	fieldName
}: Readonly<ActivityDurationFormItemProps>): JSX.Element {
	const { workdayPath, activityDurationValidator } = useActivityDuration({ fieldName });

	return (
		<FormItemWrapper
			label={I18n.get('Duration of the activity')}
			name={fieldName}
			required={required}
			rules={[
				{ required, message: I18n.get('The field requires an answer') },
				{ validator: activityDurationValidator }
			]}
			dependencies={[workdayPath]}
		>
			<InputNumber placeholder={I18n.get('Duration of the activity')} />
		</FormItemWrapper>
	);
}
